export const DetectAlphabet = (str) => {
  const arabic = /[\u0600-\u06FF]/;
  const latin = /[a-zA-Z]/;
  if (arabic.test(str)) {
    return "rtl";
  } else if (latin.test(str)) {
    return "ltr";
  } else {
    return "Neither";
  }
};
